import { render, staticRenderFns } from "./alteraSenha.vue?vue&type=template&id=910c4b1e&"
import script from "./alteraSenha.vue?vue&type=script&lang=js&"
export * from "./alteraSenha.vue?vue&type=script&lang=js&"
import style0 from "./alteraSenha.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports